import styled from 'styled-components';

export const StyledWrapper = styled.div`
    width:${props => props.width ?? '200px'};
    height:${props => props.height ?? 'auto'};
`